import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/sitelogo.svg';
import '../style/header.css';
import { Container, Row, Col } from 'react-bootstrap';
import Products from '../pages/product.js'

const Header = () => {
  return (
    <header className="d-flex justify-content-between align-items-center ">
      <Container>
        <Row>
          <Col md="6">
            <div className="d-flex align-items-center gap-2">
              <img src={logo} alt="Logo" className="headerlogo" />
            </div>
          </Col>
          <Col md="6">
            <nav className="d-flex gap-2 homeabout">
              <Link to="/" className="btn btn-outline-secondary rounded-pill">Home</Link>
              <Link to="/about" className="btn btn-outline-secondary rounded-pill">About Us</Link>
              <Link to="/product" className="btn btn-outline-secondary rounded-pill">Product</Link>
              <Link to="/vendorlistingwithmap" className="btn btn-outline-secondary rounded-pill">Listings</Link>
            </nav>
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default Header;
